import {api} from '@/api/factory';

class Season {
    constructor() {}

    removeSeason(serial_id, season_id) {
        return api({
            url: `/v1/content-manager/series/${serial_id}/seasons/${season_id}`,
            method: 'DELETE'
        })
    }

    getEpisodes(serial_id, season_id) {
        return api({
            url: `/v1/content-manager/series/${serial_id}/seasons/${season_id}/episodes`,
            method: 'GET'
        })
    }

    updateVoiceoversOrder(serial_id: number | string, season_id: number | string, order: Array<{ content_source_id: number; sort_order: number }>) {
        return api({
            url: `/v1/content-manager/series/${serial_id}/seasons/${season_id}/voiceovers/order`,
            method: 'PUT',
            data: { voiceovers: order }
        })
    }

    getVoiceoversOrder(serial_id: number | string, season_id: number | string) {
        return api.get(`/v1/content-manager/series/${serial_id}/seasons/${season_id}/voiceovers/order`)
    }

    resetVoiceoversOrder(serial_id: number | string, season_id: number | string) {
        return api({
            url: `/v1/content-manager/series/${serial_id}/seasons/${season_id}/voiceovers/order`,
            method: 'DELETE'
        })
    }
}

export default Season